import featureDiscoveryFlag from "../../../../src/pages/foundations/content/designing-messages/feature-discovery/_assets/feature-discovery-flag.png";
import featureDiscoveryStart from "../../../../src/pages/foundations/content/designing-messages/feature-discovery/_assets/feature-discovery-start.png";
import featureDiscoveryBitbucket from "../../../../src/pages/foundations/content/designing-messages/feature-discovery/_assets/feature-discovery-bitbucket.png";
import * as React from 'react';
export default {
  featureDiscoveryFlag,
  featureDiscoveryStart,
  featureDiscoveryBitbucket,
  React
};